import React from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import { useAllQuery } from '../utils/hooks/reactQuery/queries'

const IterableCalendar = () => {
  const {
    data: campaigns = [],
    isError,
    isLoading,
  } = useAllQuery('iterable-campaigns')

  return (
    <FullCalendar
      plugins={[dayGridPlugin, listPlugin]}
      initialView="dayGridMonth"
      headerToolbar={{
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,listDay,listWeek',
      }}
      views={{
        listDay: { buttonText: 'List Day' },
        listWeek: { buttonText: 'List Week' },
        dayGridMonth: { buttonText: 'Month' },
      }}
      dayMaxEventRows={3}
      events={campaigns
        .filter((campaign) => campaign.hasOwnProperty('startAt'))
        .map((campaign, index) => ({
          title: campaign.name,
          start: new Date(campaign.startAt).toISOString(),
          backgroundColor: index % 2 ? '#007bff' : '#00c9ff',
        }))}
    />
  )
}

export default IterableCalendar
